import { toastStore } from 'shared/ui'

export const showAIAgentDisabledToast = () =>
  toastStore.add({
    title: 'AI Agent disabled',
    type: 'info',
  })
